<lokos-button
    [type]="'refresh'"
    [isIcon]="true"
    [iconPath]="'assets/images/rotate.svg'"
    (afterClick)="refreshBtn()"
    [label]="'refreshData'"
>
</lokos-button>
